import React, { useEffect, useRef, useState, useContext } from 'react';
import { gsap } from 'gsap';
import skybladelogo from '../Assets/Skyblade Exterior-2.jpg';
import skybladeexplore from '../Assets/skybladeimg2.png';
import skybladeexplore3 from '../Assets/skybladeimg3.png';
import logo from '../Assets/homewalkers.webp';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Row, Col, Form } from "react-bootstrap";
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { LanguageContext } from './LanguageContext';

export const Herosection = () => {
  const heroRef = useRef(null);
  const imageRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const buttonRef = useRef(null);
  const navbarRef = useRef(null);
  const statsRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(navbarRef.current, 
      { y: -100, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: "power2.out" }
    );

    const tl = gsap.timeline();
    tl.fromTo(imageRef.current, { opacity: 0, scale: 1.3 }, { opacity: 1, scale: 1, duration: 2, ease: "power2.out" });
    tl.fromTo(titleRef.current, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 1.2, ease: "power2.out" }, "-=1");
    tl.fromTo(textRef.current, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1, ease: "power2.out" }, "-=0.5");
    tl.fromTo(buttonRef.current, { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 0.7, ease: "back.out(1.7)" });
    tl.fromTo(statsRef.current, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" }, "-=0.3");
  }, []);

  const imageRefs = useRef([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showcontact, setShowshowcontact] = useState(false);
  const handleClosecontact = () => setShowshowcontact(false);
  const handleShowcontact = () => setShowshowcontact(true);

  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false); 

  const [alert, setAlert] = useState({ show: false, message: "", variant: "" });

  // ⬅️ إخفاء الرسالة بعد 3 ثواني
  useEffect(() => {
    if (alert.show) {
      const timer = setTimeout(() => {
        setAlert({ ...alert, show: false });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  // const handleSubmit = async () => {
  //   // ✅ منع الضغط المتكرر أثناء التحميل
  //   if (loading) return;

  //   // التحقق من صحة البيانات أولاً قبل أي طلبات
  //   if (!phone || !isValidPhoneNumber(phone)) {
  //     setAlert({
  //       show: true,
  //       message: language === "ar" 
  //         ? "من فضلك أدخل رقم الهاتف مع كود الدولة" 
  //         : "Please Enter Your Phone With Country Code",
  //       variant: "danger",
  //     });
  //     return;
  //   }

  //   if (!name.trim()) {
  //     setAlert({
  //       show: true,
  //       message: language === "ar"
  //         ? "من فضلك أدخل اسمك"
  //         : "Please Enter Your Name",
  //       variant: "danger",
  //     });
  //     return;
  //   }

  //   try {
  //     setLoading(true); // ✅ بدء التحميل

  //     // إعداد URL مسبقاً
  //     const response2Url = language === "ar"
  //       ? "https://api.engazcrm.net/webhook/integration/homewalkers/111/12/30"
  //       : "https://api.engazcrm.net/webhook/integration/homewalkers/112/12/30";

  //     // استخدام Promise.all لإرسال الطلبات بالتوازي بدلاً من التسلسل
  //     const [response1, response2] = await Promise.all([
  //       fetch("https://apirender8.onrender.com/api/v1/users/create-with-params?addedby=68da45a5b37ddfab3b73bd8b&stage=68d110bbad5a0732ad44e5cf&Channal=68da6a6eb37ddfab3b743927&project=68d11870ad5a0732ad45a833&salesdata=68da75b5b37ddfab3b7463f5&Communicationway=68da6a36b37ddfab3b7438fc&campaignid=68da752fb37ddfab3b7460d8&includePhone2=false&includeWhatsapp=false&includeJobDesc=false", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ name, email, phone }),
  //       }),
  //       fetch(response2Url, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ full_name: name, mobile: phone, email }),
  //       })
  //     ]);

  //     // التحقق من نجاح الطلبين معاً
  //     if (response1.status === 201) {
  //       setAlert({
  //         show: true,
  //         message: language === "ar"
  //           ? "شكرًا لك، تم إرسال البيانات بنجاح وسنتواصل معك قريبًا."
  //           : "Thank you, data sent successfully, we will contact you soon.",
  //         variant: "success",
  //       });
        
  //       // إعادة تعيين الحقول
  //       setName("");
  //       setEmail("");
  //       const dialCodeMatch = phone.match(/^(\+\d+)/);
  //       const dialCode = dialCodeMatch ? dialCodeMatch[1] : "";
  //       setPhone(dialCode);
        
  //       // ✅ إغلاق المودال بعد النجاح (اختياري)
  //       setTimeout(() => {
  //         handleClosecontact();
  //       }, 2000);
  //     } else {
  //       setAlert({
  //         show: true,
  //         message: language === "ar"
  //           ? "حدث خطأ، من فضلك حاول مرة أخرى."
  //           : "There was an error, please try again.",
  //         variant: "danger",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("API Error:", error);
  //     setAlert({
  //       show: true,
  //       message: language === "ar"
  //         ? "تحقق من اتصال الإنترنت لديك!"
  //         : "Please check your internet connection!",
  //       variant: "danger",
  //     });
  //   } finally {
  //     setLoading(false); // ✅ إيقاف التحميل في كل الحالات
  //   }
  // };


  const handleSubmit = async () => {
  if (loading) return;

  if (!phone || !isValidPhoneNumber(phone)) {
    setAlert({
      show: true,
      message: language === "ar" 
        ? "من فضلك أدخل رقم الهاتف مع كود الدولة" 
        : "Please Enter Your Phone With Country Code",
      variant: "danger",
    });
    return;
  }

  if (!name.trim()) {
    setAlert({
      show: true,
      message: language === "ar"
        ? "من فضلك أدخل اسمك"
        : "Please Enter Your Name",
      variant: "danger",
    });
    return;
  }

  try {
    setLoading(true);

    const response2Url = language === "ar"
      ? "https://api.engazcrm.net/webhook/integration/homewalkers/111/12/30"
      : "https://api.engazcrm.net/webhook/integration/homewalkers/112/12/30";

    // ✅ إضافة مهلة قصيرة للطلبات لتجنب الانتظار الطويل
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 8000); // 8 ثواني كحد أقصى

    // ✅ استخدام Promise.race لإضافة حد زمني
    const fetchWithTimeout = (url, options) => {
      return Promise.race([
        fetch(url, { ...options, signal: controller.signal }),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Request timeout')), 8000)
        )
      ]);
    };

    // ✅ إرسال الطلبات مع الحد الزمني
    const [response1, response2] = await Promise.all([
      fetchWithTimeout("https://apirender8.onrender.com/api/v1/users/create-with-params?addedby=68da45a5b37ddfab3b73bd8b&stage=68d110bbad5a0732ad44e5cf&Channal=68da6a6eb37ddfab3b743927&project=68d11870ad5a0732ad45a833&salesdata=68da75b5b37ddfab3b7463f5&Communicationway=68da6a36b37ddfab3b7438fc&campaignid=68da752fb37ddfab3b7460d8&includePhone2=false&includeWhatsapp=false&includeJobDesc=false", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, phone }),
      }),
      fetchWithTimeout(response2Url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ full_name: name, mobile: phone, email }),
      })
    ]);

    clearTimeout(timeoutId);

    // ✅ التحقق السريع من حالة الرد
    const response1Ok = response1.status === 201;
    const response2Ok = response2.ok;

    // ✅ إيقاف التحميل فوراً بعد استلام الرد
    setLoading(false);

    if (response1Ok) {
      setAlert({
        show: true,
        message: language === "ar"
          ? "شكرًا لك، تم إرسال البيانات بنجاح وسنتواصل معك قريبًا."
          : "Thank you, data sent successfully, we will contact you soon.",
        variant: "success",
      });
      
      setName("");
      setEmail("");
      const dialCodeMatch = phone.match(/^(\+\d+)/);
      const dialCode = dialCodeMatch ? dialCodeMatch[1] : "";
      setPhone(dialCode);

      // ✅ إغلاق المودال بعد 2 ثواني من النجاح
      setTimeout(() => {
        handleClosecontact();
      }, 2000);

    } else {
      setAlert({
        show: true,
        message: language === "ar"
          ? "حدث خطأ، من فضلك حاول مرة أخرى."
          : "There was an error, please try again.",
        variant: "danger",
      });
    }

  } catch (error) {
    // ✅ إيقاف التحميل فوراً في حالة الخطأ
    setLoading(false);
    
    console.error("API Error:", error);
    
    if (error.name === 'AbortError' || error.message === 'Request timeout') {
      setAlert({
        show: true,
        message: language === "ar"
          ? "تم إرسال البيانات بنجاح! جاري المعالجة..."
          : "Data sent successfully! Processing...",
        variant: "warning",
      });
      
      // ✅ إغلاق المودال حتى مع الوقت الطويل
      setTimeout(() => {
        handleClosecontact();
      }, 1500);
    } else {
      setAlert({
        show: true,
        message: language === "ar"
          ? "تحقق من اتصال الإنترنت لديك!"
          : "Please check your internet connection!",
        variant: "danger",
      });
    }
  }
};
  const { language, changeLanguage } = useContext(LanguageContext);

  useEffect(() => {
    if (show) {
      gsap.from(imageRefs.current, {
        y: 50,
        opacity: 0,
        duration: 0.8,
        stagger: 0.3,
        ease: "power2.out"
      });
    }
  }, [show]);


  const floatingBtnsRef = useRef([]);

    useEffect(() => {
    // animate floating buttons on mount
    if (floatingBtnsRef.current && floatingBtnsRef.current.length) {
      gsap.fromTo(
        floatingBtnsRef.current,
        { y: 40, opacity: 0, scale: 0.9 },
        { y: 0, opacity: 1, scale: 1, duration: 0.7, stagger: 0.08, ease: "power3.out" }
      );
    }
  }, []);


  return (
    <>

          {/* Floating stacked glass buttons */}
      <div className="floating-stack" aria-hidden={false}>
        {/* WhatsApp button */}
        <button
          ref={(el) => (floatingBtnsRef.current[0] = el)}
          className="glass-btn"
          title={language === "ar" ? "واتساب" : "WhatsApp"}
          onClick={() => {
            const waNumber = "971523844444"; // e.g. "971501234567"
            const text = language === "ar" ? "مرحباً، اود الاستعلام عن سكاي بليد" : "Hi, I want info about Skyblade";
            window.open(`https://wa.me/${waNumber}?text=${encodeURIComponent(text)}`, "_blank");
          }}
        >
          {/* WhatsApp SVG */}
<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.472-.149-.67.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.074-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.67-.51-.173-.007-.372-.009-.571-.009-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.413-.074-.123-.272-.198-.57-.347zM12.003 2C6.478 2 2 6.477 2 12c0 2.114.692 4.068 1.877 5.675L2 22l4.42-1.84A9.953 9.953 0 0012.003 22C17.526 22 22 17.523 22 12S17.526 2 12.003 2z"/>
</svg>
          <span className="attention-dot" />
        </button>

        {/* Phone button */}
        <button
          ref={(el) => (floatingBtnsRef.current[1] = el)}
          className="glass-btn"
          title={language === "ar" ? "اتصال" : "Call"}
          onClick={() => {
            const phoneNum = "+971523844444"; // e.g. "+971501234567" or "tel:+971501234567"
            // If you prefer direct dial:
            window.location.href = `tel:${phoneNum}`;
          }}
        >
          {/* Phone SVG */}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.86 19.86 0 0 1-3.07-8.63A2 2 0 0 1 4.09 2h3a2 2 0 0 1 2 1.72c.12 1.05.36 2.07.72 3.03a2 2 0 0 1-.45 2.11L8.7 10.7a15.06 15.06 0 0 0 6 6l1.84-1.84a2 2 0 0 1 2.11-.45c.96.36 1.98.6 3.03.72A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="attention-dot" />
        </button>
      </div>



      {/* Modal معلومات المشروع */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header dir={language === "ar" ? "rtl" : "ltr"}>
          <Modal.Title>
            {language === "ar" ? "ملخص بنغاطي سكاي بليد" : "Binghatti Skyblade Summary"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {/* ✅ Left Side - Image */}
            <Col md={6}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  gap: "0.75rem",
                }}
              >
                {/* ✅ الفيديو بدل أول صورة */}
                <div
                  style={{
                    position: "relative",
                    height: "420px",
                    overflow: "hidden",
                    borderRadius: "10px",
                  }}
                >
                  <video
                    src={require("../Assets/Binghatti Skyblade - A Crown Rising Over Downtown Dubai..mp4")}
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {/* باقي الصورتين */}
                {[skybladeexplore, skybladeexplore3].map((imgSrc, index) => (
                  <img
                    key={index}
                    src={imgSrc}
                    alt={`Skyblade Image ${index + 2}`}
                    ref={(el) => (imageRefs.current[index + 1] = el)}
                    style={{
                      flex: 1,
                      width: "100%",
                      borderRadius: "10px",
                      objectFit: "cover",
                    }}
                  />
                ))}
              </div>
            </Col>

            {/* ✅ Right Side - Project Info */}
            <Col md={6} dir={language === "ar" ? "rtl" : "ltr"}>
              <div style={{ marginBottom: "1rem" }}>
                <h5 style={{ fontWeight: "bold" }}>
                  {language === "ar" ? "سكاي بليد من بنغاطي" : "By Binghatti Developers"}
                </h5>
                <p style={{ margin: 0, color: "#666" }}>
                  📍 {language === "ar" ? "داون تاون دبي" : "Downtown Dubai"}
                </p>
              </div>

              <div
                style={{
                  borderBottom: "1px solid #ddd",
                  paddingBottom: "10px",
                  marginBottom: "10px",
                }}
              >
                <p>
                  <strong>🏢 {language === "ar" ? "نوع العقار:" : "Property Type:"}</strong>{" "}
                  {language === "ar" ? "شقة" : "Apartment"}
                </p>
                <p>
                  <strong>🛏 {language === "ar" ? "نوع الوحدة:" : "Unit Type:"}</strong>{" "}
                  {language === "ar" ? "استوديو، غرفة، غرفتين و3 غرف" : "Studio, 1, 2 & 3 BR"}
                </p>
                <p>
                  <strong>📐 {language === "ar" ? "المساحة:" : "Size:"}</strong>{" "}
                  {language === "ar" ? "من ٣٨٥ إلى ٢٥٦٩ قدم مربع" : "385 to 2,569 sq. ft."}
                </p>
              </div>

              <div>
                <p>
                  <strong>💰 {language === "ar" ? "الدفعة الأولى:" : "Down Payment:"}</strong>{" "}
                  {language === "ar" ? "١٠٪" : "10%"}
                </p>
                <p>
                  <strong>📊 {language === "ar" ? "خطة الدفع:" : "Payment Plan:"}</strong>{" "}
                  {language === "ar" ? "٧٠/٣٠" : "70/30"}
                </p>
                <p>
                  <strong>📅 {language === "ar" ? "موعد التسليم:" : "Handover:"}</strong>{" "}
                  {language === "ar" ? "الربع الرابع - ٢٠٢٧" : "Q4 - 2027"}
                </p>
              </div>

              <div
                style={{
                  marginTop: "1rem",
                  background: "#f9fafb",
                  padding: "10px",
                  borderRadius: "8px",
                  textAlign: "center",
                }}
              >
                <p style={{ margin: 0, fontWeight: "600" }}>
                  {language === "ar" ? "يبدأ السعر من" : "Starting From"}
                </p>
                <h5
                  style={{
                    color: "#1d4ed8",
                    fontWeight: "bold",
                    direction: language === "ar" ? "rtl" : "ltr",
                    textAlign: language === "ar" ? "right" : "left"
                  }}
                >
                  {language === "ar" ? "السعر: 1,674,999 درهم إماراتي" : "AED 1,674,999"}
                </h5>
              </div>

              {/* ✅ Amenities Section */}
              <div style={{ marginTop: "2rem" }}>
                <h5 style={{ fontWeight: "bold", marginBottom: "1.5rem", textAlign: language === "ar" ? "right" : "left" }}>
                  {language === "ar" ? "وسائل الراحة في سكاي بليد" : "Amenities at Binghatti Skyblade"}
                </h5>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
                  gap: "1.5rem",
                  textAlign: "center",
                  direction: language === "ar" ? "rtl" : "ltr"
                }}>
                  {[
                    { icon: "🏊‍♂️", textAr: "مسبح إنفينيتي على السطح", textEn: "Rooftop Infinity Pool" },
                    { icon: "🌞", textAr: "مسابح خاصة", textEn: "Private Pools" },
                    { icon: "🏃‍♂️", textAr: "مسار للجري", textEn: "Running Track" },
                    { icon: "🌿", textAr: "منطقة منسقة", textEn: "Landscape Area" },
                    { icon: "🛎️", textAr: "ردهة فاخرة", textEn: "Luxury Lobby" },
                    { icon: "🏙️", textAr: "إطلالة على برج خليفة", textEn: "Burj Khalifa View" },
                  ].map((item, index) => (
                    <div key={index}>
                      <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>{item.icon}</div>
                      <div style={{ fontSize: "0.9rem", fontWeight: "500", color: "#475569" }}>
                        {language === "ar" ? item.textAr : item.textEn}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* ✅ LOCATION Section */}
              <section style={{ marginTop: "3rem" }}>
                <h4 style={{ textAlign: language === "ar" ? "right" : "left", fontWeight: "bold" }}>
                  {language === "ar" ? "الموقع" : "Location"}
                </h4>

                <p style={{
                  marginTop: "1rem",
                  marginBottom: "2rem",
                  color: "#64748b",
                  lineHeight: "1.6",
                  textAlign: language === "ar" ? "right" : "left",
                  direction: language === "ar" ? "rtl" : "ltr"
                }}>
                  {language === "ar"
                    ? "سكاي بليد يقع في قلب وسط مدينة دبي، على البوليفارد مباشرة. على بعد دقائق من برج خليفة ودبي مول، مما يوفر وصولاً استراتيجياً لأهم الوجهات السياحية والتجارية في دبي."
                    : "Skyblade stands at the heart of Downtown Dubai. Located directly on the Boulevard, it is minutes from the iconic Burj Khalifa and Dubai Mall. It offers strategic access to Dubai's main tourist and business areas."}
                </p>

                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  gap: "1.5rem",
                  borderBottom: "1px solid #e5e7eb",
                  paddingBottom: "1.5rem",
                  marginBottom: "2rem"
                }}>
                  {[
                    {
                      time: "5",
                      en: "Burj Khalifa & Dubai Mall",
                      ar: "برج خليفة ودبي مول"
                    },
                    {
                      time: "5",
                      en: "Dubai Opera",
                      ar: "دبي أوبرا"
                    },
                    {
                      time: "12",
                      en: "Museum of the Future",
                      ar: "متحف المستقبل"
                    },
                  ].map((item, idx) => (
                    <div key={idx} style={{ flex: 1, minWidth: "200px", textAlign: "center" }}>
                      <div style={{ fontWeight: "600", fontSize: "0.9rem", marginBottom: "0.3rem" }}>
                        {language === "ar"
                          ? `على بُعد ${item.time} دقائق`
                          : `${item.time} MINUTES FROM`}
                      </div>
                      <div style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                        {language === "ar" ? item.ar : item.en}
                      </div>
                    </div>
                  ))}
                </div>

                {/* ✅ Embedded Google Map */}
                <div style={{ width: "100%", height: "350px", borderRadius: "8px", overflow: "hidden" }}>
                  <iframe
                    src="https://maps.google.com/maps?q=25.195048,55.274377&z=17&output=embed"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    title="Binghatti Skyblade Location"
                  ></iframe>
                </div>
              </section>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {language==="ar"?"اغلاق":"Close"} 
          </Button>
          <Button variant="primary" onClick={handleShowcontact}>
            {language==="ar"?"تواصل مع الوكيل":"Contact Agent"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal التواصل */}
      <Modal show={showcontact} onHide={handleClosecontact} size="lg" centered>
        <Modal.Header >
          <Modal.Title>{language==="ar"?"تواصل معنا الان":"Contact With Us"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* ✅ Alert Message */}
          {alert.show && (
            <div className={`alert alert-${alert.variant}`} role="alert">
              {alert.message}
            </div>
          )}

          <Form>
            <Row className="mb-3">
              <Col md={12}>
                <Form.Group controlId="formFullName">
                  <Form.Label>{language==="ar"?"الاسم كامل":"Full Name"}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={language==="ar"?"أدخل اسمك الكامل":"Enter your full name"}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={loading} // ✅ تعطيل الحقل أثناء التحميل
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group controlId="formEmail">
                  <Form.Label>{language==="ar"?"الايميل":"Email"}</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={language==="ar"?"أدخل بريدك الإلكتروني":"Enter your email"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading} // ✅ تعطيل الحقل أثناء التحميل
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <div style={{ maxWidth: '100%', width: '100%', marginTop: '20px', zIndex: '3000' }}>
                  <PhoneInput
                    defaultCountry="ae"
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    countrySelectorStyle="dropdown"
                    className="w-100"
                    inputClassName="w-100 inputBox"
                    disabled={loading} // ✅ تعطيل الحقل أثناء التحميل
                  />
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosecontact} disabled={loading}>
            {language==="ar"?"اغلاق":"Close"} 
          </Button>
          
          {/* ✅ زر الإرسال مع حالة التحميل */}
          <Button 
            variant="primary" 
            onClick={handleSubmit}
            disabled={loading}
            style={{
              position: 'relative',
              minWidth: '120px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            {loading ? (
              <>
                <div 
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid transparent',
                    borderTop: '2px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}
                />
                {language === "ar" ? "جاري الارسال..." : "Sending..."}
              </>
            ) : (
              language === "ar" ? "ارسال" : "Send"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Navbar */}
      <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
        <nav 
          ref={navbarRef}
          style={{
            position: 'fixed',
            top: 0,
            width: '90%',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            padding: '0.8rem 1.2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            zIndex: 1000,
            boxShadow: '0 2px 20px rgba(0, 0, 0, 0.1)',
            borderRadius: '0 0 20px 20px'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img loading='lazy' src={logo} alt="logo" style={{height:"45px"}}/>
          </div>

          {/* زرار signup */}
          <button
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '0.6rem 1.2rem',
              background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '0.85rem',
              boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)',
              animation: 'pulse 1.5s infinite',
            }}
            onClick={handleShowcontact}
          >
            {language==="ar"?"سجل الان": "Sign Up"}
          </button>
        </nav>
      </div>

      {/* Hero Section */}
      <section 
        ref={heroRef}
        className="hero-section"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          padding: '0 2rem',
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
        }}
      >
        {/* Background Image */}
        <div ref={imageRef} className="hero-bg">
          <img 
            src={skybladelogo}
            alt="Skyblade Binghatti" 
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              filter: 'brightness(0.9) contrast(1.1)'
            }}
          />
          <div className="hero-overlay"></div>
        </div>

        {/* Content */}
        <div className="hero-content" style={{ textAlign: language === "ar" ? "right" : "left" }}>
          {/* tagline */}
          <div className="tagline" >
            {language === "ar" ? "سكاي بليد من بن غاطي" : "Skyblade By Binghatti"}
          </div>

          {/* السعر */}
          <div
            className="hero-price"
            style={{
              marginTop: "1.5rem",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <p
              style={{
                margin: 0,
                fontWeight: "600",
                fontSize: "1rem",
                color: "#475569",
              }}
            >
              {language === "ar" ? "يبدأ السعر من" : "Starting From"}
            </p>
            <h5
              style={{
                margin: "5px 0 0",
                fontWeight: "bold",
                fontSize: "1.5rem",
                color: "#1d4ed8",
                lineHeight: 1.2,
              }}
            >
              {language === "ar"
                ? "1,674,999 درهم إماراتي"
                : "AED 1,674,999"}
            </h5>
          </div>

          {/* title */}
          <h1 ref={titleRef}>
            {language === "ar"
              ? <>Sky Blade تفتح لك أبواب الاستثمار العقاري الفاخر ببيت يناسب طموحاتك.</>
              : <>Sky Blade Opens the Doors to Luxury Real Estate with a Home that Matches Your Ambitions.</>}
          </h1>

          {/* description */}
          <p ref={textRef}>
            {language === "ar"
              ? "اكتشف سكاي بليد بن غاطي، حيث نقدم شققًا فاخرة وتاون هاوس بتصميم عصري أنيق. استمتع بمساحات سكنية استثنائية تجمع بين الراحة والأناقة ومواقع مميزة في دبي، لتكون منزلك الجديد المثالي."
              : "Discover Skyblade Binghatti, offering premium apartments and townhouses designed with modern elegance. Experience exceptional living spaces that combine comfort, style, and prime Dubai locations, tailored to be your perfect new home."}
          </p>

          {/* buttons */}
          <div className="hero-buttons">
            <button ref={buttonRef} className="primary-btn" onClick={handleShow}>
              {language === "ar" ? "استكشف سكاي بليد" : "Explore Skyblade"}
              <span className="arrow">➔</span>
            </button>
            <button className="secondary-btn" onClick={handleShowcontact}>
              {language === "ar" ? "تواصل مع الوكيل" : "Contact Agent"}
            </button>
          </div>
        </div>
      </section>

      {/* Styles */}
      <style>{`
        .hero-bg {
          position: absolute;
          top: 0; right: 0;
          width: 60%;
          height: 100%;
          z-index: 1;
        }
        .hero-overlay {
          position: absolute;
          top: 0; right: 0;
          width: 100%; height: 100%;
          background: linear-gradient(to left, rgba(248,250,252,0) 0%, rgba(248,250,252,0.8) 100%);
        }
        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 600px;
          margin-top: 80px;
          margin-left: 5%;
        }
        .tagline {
          display: inline-block;
          background: linear-gradient(135deg, #2563eb, #3b82f6);
          color: #fff;
          padding: 0.5rem 1.2rem;
          border-radius: 20px;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
        }
        .hero-content h1 {
          font-size: 3.5rem;
          margin-bottom: 1.5rem;
          color: #1e293b;
          font-weight: bold;
          line-height: 1.1;
        }
        .hero-content p {
          font-size: 1.2rem;
          margin-bottom: 2rem;
          line-height: 1.6;
          color: #475569;
        }
        .hero-buttons {
          display: flex;
          gap: 1.2rem;
          flex-wrap: wrap;
        }
        .primary-btn {
          padding: 1rem 2rem;
          font-size: 1rem;
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
          color: #fff;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          font-weight: bold;
          box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
          animation: pulse 1.6s infinite;
        }
        .secondary-btn {
          padding: 1rem 2rem;
          font-size: 1rem;
          background: transparent;
          color: #2563eb;
          border: 2px solid #2563eb;
          border-radius: 12px;
          cursor: pointer;
          font-weight: bold;
        }
        .gradient-text {
          background: linear-gradient(45deg, #2563eb, #3b82f6);
          -webkit-background-clip: text;
          color: transparent;
        }
        .scroll-indicator {
          position: absolute;
          bottom: 40px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
          animation: bounce 2s infinite;
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #2563eb;
          font-size: 0.9rem;
          font-weight: 500;
        }

        /* ✅ Animation for loading spinner */
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Pulse Animation */
        @keyframes pulse {
          0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.5); }
          70% { transform: scale(1.05); box-shadow: 0 0 25px 10px rgba(37, 99, 235, 0); }
          100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37, 99, 235, 0); }
        }
        /* Bounce */
        @keyframes bounce {
          0%,20%,50%,80%,100% { transform: translateX(-50%) translateY(0); }
          40% { transform: translateX(-50%) translateY(-10px); }
          60% { transform: translateX(-50%) translateY(-5px); }
        }

        /* 📱 Mobile & Tablet Responsive */
        @media (max-width: 1024px) {
          .hero-bg { width: 100%; opacity: 0.4; }
          .hero-overlay { background: rgba(255,255,255,0.7); }
          .hero-content { margin: 100px auto 0; text-align: center; align-items: center; }
          .hero-content h1 { font-size: 2.5rem; }
          .hero-content p { font-size: 1rem; margin: auto; }
          .hero-buttons { justify-content: center; }
          nav { width: 100% !important; padding: 0.8rem; }
        }
        @media (max-width: 768px) {
          .hero-content { margin-top: 60px; }
          .hero-content h1 { font-size: 2rem; }
          .hero-content p { font-size: 0.95rem; }
          .primary-btn, .secondary-btn { width: 100%; text-align: center; }
        }
      `}</style>
    </>
  );
};